module.exports = __webpack_public_path__ + "static/media/g-icon-add_large.ced481b6.svg";